<template>
<div :class="$style.tags" :id="id">
  <div :class="[!showPills?'mt-related-families--open':'']" class="mt-related-families mt-related-families--hash mt-related-families--group" v-if="maxFamiliesCount>0">
    <span class="mt-related-families--group_open-btn" @click="changePillStatus">
      {{ relatedFamiliesGroupName }}
      <span>+{{ maxFamiliesCount }}</span>
      <span class="icon-status-pill"></span>
    </span>
    <fou-modal :id="$vId(this, 'submission-progress')" cols="8">
      <template #trigger>
        <button @click="removeGroupModal(true)" type="button" class="close"></button> <!-- button  -->
      </template>
      <template #content v-if="isRemoveGroupModalVisible">
      <div :class="$style.slotContent">
        <h3 class="mt-h3" :class="$style.modalTitle">{{$t('pages.submissions.components.descriptions.remove_familiy_modal.group_title', {familyName: relatedFamiliesGroupName, familiesCount: maxFamiliesCount })}}</h3>
        <fou-group bottom="medium">
          <p :class="$style.modalDescription">{{$t('pages.submissions.components.descriptions.remove_familiy_modal.group_description', {familyName: relatedFamiliesGroupName, familiesCount: maxFamiliesCount })}}</p>
        </fou-group>
        <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
          <button
            type="button"
            class="mt-button mt-button--inverted"
            @click="hide();removeGroupModal(false)"
            :class="$style.modalControlsItem"
            >
              {{$t('pages.submissions.components.descriptions.remove_familiy_modal.cancel_remove')}}
          </button>
          <button
            type="button"
            class="mt-button"
            :class="$style.modalControlsItem"
            @click="removeFamilyGroup(); hide()"
            >
              {{$t('pages.submissions.components.descriptions.remove_familiy_modal.confirm_remove')}}
        </button>
        </fou-group>
      </div>
      </template>
    </fou-modal>
  </div>
  <div v-if="showPills" v-for="(option, key) in valueAsArray()" :key="key" :class="$style.tag">
    <span class="mt-related-families mt-related-families--hash" :class="[{[$style.errorColor] : !validateScriptRegex(option.label)}]" :id="`${id}-tag${key}` " slot="trigger">
      {{ option.label }}
      <fou-modal :id="$vId(this, 'submission-progress')" cols="8">
        <template #trigger>
          <button @click="isRemoveIndividualModalVisible = true" type="button" class="close"></button> <!-- button  -->
        </template>
        <template #content v-if="isRemoveIndividualModalVisible">
        <div :class="$style.slotContent">
          <h3 class="mt-h3" :class="$style.modalTitle">{{$t('pages.submissions.components.descriptions.remove_familiy_modal.title', {familyName: option.label})}}</h3>
          <fou-group bottom="medium">
            <p :class="$style.modalDescription">{{$t('pages.submissions.components.descriptions.remove_familiy_modal.description', {familyName: option.label})}}</p>
          </fou-group>
          <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
            <button
              type="button"
              class="mt-button mt-button--inverted"
              @click="hide();isRemoveIndividualModalVisible = false"
              :class="$style.modalControlsItem"
            >
                {{$t('pages.submissions.components.descriptions.remove_familiy_modal.cancel_remove')}}
            </button>
            <button
              type="button"
              class="mt-button"
              :class="$style.modalControlsItem"
              @click="remove(key);"
            >
                {{$t('pages.submissions.components.descriptions.remove_familiy_modal.confirm_remove')}}
            </button>
          </fou-group>
        </div>

        </template>

      </fou-modal>
    </span>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import FouModal from 'components/overlay/fou-modal/'
import FouGroup from 'components/layout/fou-group/'
import {mapActions, mapGetters} from 'vuex'
import Misc from 'src/utils/helper/misc'

export default {
  name: 'fou-select-families',

  data () {
    return {
      showPills: true,
      isRemoveIndividualModalVisible: false,
      isRemoveGroupModalVisible: false
    }
  },

  components: {
    FouModal,
    FouGroup
  },

  props: {
    fouSelect: {
      type: Object,
      required: true
    },
    fouSelectId: {
      type: String,
      default: null
    },
    editable: {
      type: Boolean,
      default: false
    },
    tagsCustom: {
      type: Boolean,
      default: false
    },
    customColor: {
      type: Object,
      default: () => ({})
    },
    removable: {
      type: Boolean,
      default: true
    }
  },

  created () {
    this.$events.$on('fou-select-tags:update', this.update)
    this.$events.$on('family-group:update', this.removeFamilyGroup)
  },

  beforeUnmount () {
    this.$events.$off('fou-select-tags:update', this.update)
    this.$events.$off('family-group:update', this.removeFamilyGroup)
  },

  methods: {
    ...mapActions('overlay', ['hide']),
    ...Misc,
    removeGroupModal (value) {
      this.isRemoveGroupModalVisible = value
    },
    removeFamilyGroup () {
      this.isRemoveGroupModalVisible= false
      this.fouSelect.values = []
      this.$emit('on:remove', undefined)
    },
    remove (key) {
      this.isRemoveGroupModalVisible= false;
      this.isRemoveIndividualModalVisible = false
      this.hide()
      this.fouSelect.remove(key)
      this.$events.$emit('fou-select:update', this.fouSelectId)
      this.$emit('on:remove', key)
    },
    update () {
      /**
       * In case of non-reactive data, make sure data is updated, too.
       */
      this.$forceUpdate()
    },
    save (option) {
      /**
       * This.fouSelect.values is reactive.
       * By overriding it, on-change of fou-select will be triggered.
       */
      this.fouSelect.values = this.fouSelect.values.map(v => {
        if (v.value === option.value) {
          v.label = option.edit
        }
        return v
      })
      this.fouSelect.options.some(o => {
        if (o.value === option.value) {
          o.label = option.edit
          return true
        }
      })
      this.hide()
    },
    valueAsArray () {
      let values = this.fouSelect.values || []
      values.forEach(v => {
        v.edit = v.label
      })
      return values
    },
    changePillStatus () {
      this.showPills = !this.showPills
    }
  },

  computed: {
    ...mapGetters('submissions', ['selectedRelatedFamilies']),
    relatedFamiliesGroupName () {
      const lastSelected = this.selectedRelatedFamilies?.[0]
      return lastSelected?.familyName || ''
    },
    maxFamiliesCount () {
      return (this.fouSelect.values?.length) ? this.fouSelect.values.length - 1 : 0
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/variables/colors';

.tags {
  margin: 0 rem(-4);
}
.tag {
  display: inline-block;
}

.modalContent {
  padding: rem(20);
}

.errorColor {
  background-color: #e3152e;
}

.slotContent {
  padding: 3.125rem 5rem;
}
.modalTitle {
  &::after {
    content: "";
    display: block;
    margin: rem(20);
    border-top: 1px solid map-get($colors, 'grey');
  }
}

.modalDescription{
  text-align: center;
}

.modalControls{
  margin-left: rem(-5);
  margin-right: rem(-5);
}

.modalControlsItem{
  flex: 1;
  margin: 0 rem(5);
}
</style>
